@use '@/styles/tokens' as *;

.body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: 20px 34px;
  background: $color-green-secondary-900;
}

.headerLeft {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

/* Lighten the shimmer over the dark-green header so it stays visible. */
.onDark {
  opacity: 0.35;
}

.thread {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  overflow: hidden;
  background: var(--surface, #fff);
}

.bubbleRow {
  display: flex;
  max-width: 64%;
}

.bubbleMine {
  align-self: flex-end;
  justify-content: flex-end;
}

.bubble {
  width: 100%;
}

.composer {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  border-top: 1px solid $color-neutral-200;
}

.composerInput {
  flex: 1;
}
